module.exports = __webpack_public_path__ + "static/media/coverPhoto.a7ea8fd6.jpg";